import { render, staticRenderFns } from "./xskVideoManage.vue?vue&type=template&id=169db32b&"
import script from "./xskVideoManage.vue?vue&type=script&lang=js&"
export * from "./xskVideoManage.vue?vue&type=script&lang=js&"
import style0 from "./xskVideoManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports